/* eslint-disable no-useless-escape */
/* 

  Regex

*/

export const REGEX_PASSWORD =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[\*\^\°\!\“\§\$\%\&\/\(\)\=\?\´\`\+\*\#\’\,\;\.\:\-\_]).{12,}/g;
